<template>
  <div class="question-component">
    <transition-group key="commom-question" name="content-fade" appear>
      <div key="commom-question" class="commom-questions-component">
        <ContainerWrapper size="md">
          <NavBar
            :display-close-button="false"
            :extended="true"
            :title="current.title || titleName"
            @back="backStep"
          />
          <div class="content">
            <div v-if="!detail" class="list">
              <div class="questions">
                <ListItem
                  v-for="(question, index) in questions"
                  :key="index"
                  class="question"
                  @click="handleQuestionClick(question)"
                >
                  <template #description>
                    {{ question.title }}
                  </template>
                </ListItem>
              </div>
            </div>

            <div v-else class="current">
              <div class="question-content">
                <div class="answer" v-html="currentFaqAnswer" />
              </div>
            </div>
          </div>
        </ContainerWrapper>
      </div>
    </transition-group>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import NavBar from '@/aasgard/components/navigation/NavBar.vue'
import ContainerWrapper from '@/components/ui/newComponents/ContainerWrapper.vue'
import ListItem from '@/aasgard/components/lists/ListItem.vue'
import { sanitizeHtmlContent } from '~/helpers/html-sanitize'
export default {
  name: 'CommomQuestions',
  components: {
    NavBar,
    ContainerWrapper,
    ListItem,
  },
  props: {
    questions: { type: Array, default: () => [] },
    titleName: { type: String, default: 'Dúvidas frequentes' },
    subject: { type: String, default: '' },
    directQuestion: { type: Object, default: undefined },
  },
  emits: ['close'],
  data() {
    return {
      detail: false,
      current: {},
    }
  },
  computed: {
    currentFaqAnswer() {
      return sanitizeHtmlContent(this.current?.text, {
        ALLOWED_TAGS: [
          'b',
          'i',
          'em',
          'strong',
          'a',
          'ul',
          'ol',
          'li',
          'p',
          'br',
          'div',
          'h1',
          'h2',
          'h3',
          'h4',
          'h5',
          'h6',
        ],
        ALLOWED_ATTR: {
          a: ['href', 'target'],
        },
        allowedIframeHostnames: ['www.youtube.com'],
      })
    },
  },
  beforeMount() {
    if (this.directQuestion) {
      this.detail = true
      this.current = this.directQuestion
    }
  },
  mounted() {
    if (this.subject) {
      this.actEmitGaEvent({
        eventCategory: `${this.subject}-faq`,
        eventAction: 'displayed',
        eventLabel: 'displayed',
      })
    }
  },
  methods: {
    ...mapActions({
      actEmitGaEvent: 'services/ga/actEmitGaEvent',
    }),
    backStep() {
      if (!this.detail || this.directQuestion) {
        this.$emit('close')
      } else {
        this.detail = false
      }
    },
    handleQuestionClick(question) {
      this.current = question
      this.detail = true

      if (this.subject) {
        this.actEmitGaEvent({
          eventCategory: `${this.subject}-faq`,
          eventAction: 'question-click',
          eventLabel: question.title,
        })
      }
    },
  },
}
</script>
<style lang="scss">
.question-component {
  display: flex;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 10032;

  & > .commom-questions-component {
    max-height: 100%;
    overflow: auto;
    margin: 0;
    top: 0;
    left: 0;
    min-width: 100vw;
    min-height: 100vh;
    position: fixed;
    background: $color-white-high;
    z-index: 100;

    & > .ContainerWrapper {
      & > .content {
        & > .list {
          & > h1 {
            @include headline-5;
            color: $color-black-high;
            padding: 0;
            margin: 0;

            @include desktop {
              font-size: 28px;
              line-height: 36px;
              margin-bottom: 32px;
            }
          }

          & > .questions {
            padding: 0 16px;

            & > .question {
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 20px 0;

              &:not(:last-child) {
                border-bottom: 1px solid rgba(0, 0, 0, 0.12);
              }

              &:hover {
                cursor: pointer;
              }

              & > .content {
                & > .description {
                  @include body-1;
                  color: $color-black-high;
                }
              }
            }
          }
        }

        & > .current {
          padding: 0 16px;
          & > .question-content {
            & > .answer {
              margin-top: 0;
              @include body-1;
              color: $color-black-high;

              & > ul {
                list-style-type: disc;
              }

              & > ol {
                list-style-type: decimal;
              }

              & > ul,
              & > ol {
                padding-left: 16px;

                & > li {
                  @include body-1;
                  color: $color-black-high;
                  margin-top: 0;
                }
              }

              & > a {
                color: $color-brand-primary;
              }
            }
          }
        }
      }

      & .still-doubt {
        margin-top: 32px;
        padding: 16px;
        width: calc(100% + 32px);
        margin-left: -16px;
        background: $color-neutral-light;

        & > p {
          margin: 0 0 24px;
          @include body-2;
          color: #000;
        }

        & > .Button {
          width: 100%;
        }
      }
    }
  }
}

.content-fade {
  @at-root {
    #{&}-enter-active,
    #{&}-leave-active {
      transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
    }
    #{&}-enter-from,
    #{&}-leave-to {
      transform: translateY(100px);
      opacity: 0;
    }
  }
}
</style>
